module.exports = __webpack_public_path__ + "static/media/htmlLogo.abfa4f1f.png";